import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-powered-by">
          <span className="powered-by">Powered by</span>{' '}
          <a 
            href="https://enterprisewebsolutions.co/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-link"
          >
            Enterprise Web Solutions
          </a>
        </p>
        <div className="footer-credit-cards">
          <a 
            href="https://www.visa.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="credit-card-link"
          >
            <img src="/visa.png" alt="Visa" className="credit-card-logo" />
          </a>
          <a 
            href="https://www.mastercard.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="credit-card-link"
          >
            <img src="/mastercard.png" alt="Mastercard" className="credit-card-logo" />
          </a>
          <a 
            href="https://www.discover.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="credit-card-link"
          >
            <img src="/discover.png" alt="Discover" className="credit-card-logo" />
          </a>
        </div>
        <div className="footer-links">
          <Link to="/terms" className="footer-link">Terms</Link>
          <Link to="/privacy" className="footer-link">Privacy</Link>
          <Link to="/refund" className="footer-link">Refund</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

